import Checkbox from "../../form/Checkbox";
import Textarea from "../../form/Textarea";
import Select from "../../form/select/Select";
import Input from "../../form/Input";
import { t } from "i18next";

const AdvancedSettingsTicket = ({ values, handleFormChange = () => {} }) => {
  const options = [
    {
      value: "visible",
      name: t("Visible"),
    },
    {
      value: "hidden",
      name: t("Hidden"),
    },
    // {
    //   value: "hiddennotsale",
    //   name: "Visibility when not on sale",
    // },
    // {
    //   value: "custom",
    //   name: "Custom schedule",
    // },
  ];

  const salesChanneloptions = [
    {
      value: "everywhere",
      name: "Everywhere",
    },
    {
      value: "onlineonly",
      name: "Online only",
    },
    {
      value: "dooronly",
      name: "At the door only",
    },
  ];

  return (
    <div className="space-y-4 py-4">
      <div className="relative">
        <Checkbox
          checkboxName="showTicketOnSale"
          checkboxLabel={t(
            "Show ticket sale end dates and sale status at checkout"
          )}
          checkboxLableClass={"text-base"}
          checked={values?.showTicketOnSale}
          onChange={handleFormChange}
        />
      </div>
      <div className="relative">
        <Textarea
          label={t("Description")}
          labelClasses={"!text-lg !text-deep-purple !mb-2"}
          inputPlaceholder={t("Tell attendees more about this ticket.")}
          inputClasses={
            "!border-surface-05 !bg-surface-04 !font-medium !text-deep-purple"
          }
          noteClasses={"text-slate-500 text-right"}
          inputName={"excerpt"}
          onChange={handleFormChange}
          inputValue={values?.excerpt}
        />
      </div>
      <div className="relative">
        <Select
          dropdownData={options}
          selectedValue={values?.visibility}
          onChange={(val) => {
            handleFormChange({ target: { name: "visibility", value: val } });
          }}
          label={t("Visibility")}
          placeholder={t("Select visibility")}
          required={true}
          xPlacement="bottom"
          onSearchHandler={(e) => console.log("Search input:", e.target.value)}
          dropdownClass={"w-full"}
          dropdownButtonClass={
            "rounded-md !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple !rounded-md border-slate-300"
          }
          labelClasses={"text-lg text-deep-purple"}
        />
      </div>
      <div className="relative">
        <div className="font-medium font-CanelaDeck text-lg !text-deep-purple mb-2">
          {t("Tickets per order")}
        </div>
        <div className="grid grid-cols-2 gap-5">
          <div className="relative">
            <Input
              label={t("Min quantity")}
              labelClasses={"!text-base !text-deep-purple !mb-2"}
              inputClasses={
                "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
              }
              inputName={"quantityMin"}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  e.target.value = value;
                  handleFormChange(e);
                }
              }}
              value={values?.quantityMin}
            />
          </div>
          <div className="relative">
            <Input
              label={t("Max quantity")}
              labelClasses={"!text-base !text-deep-purple !mb-2"}
              inputClasses={
                "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
              }
              inputName={"quantityMax"}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  e.target.value = value;
                  handleFormChange(e);
                }
              }}
              value={values?.quantityMax}
            />
          </div>
        </div>
      </div>
      {/* <div className="relative">
        <Select
          dropdownData={salesChanneloptions}
          selectedValue={values?.salesChannel}
          onChange={(val) => {
            console.log(val);
            handleFormChange({ target: { name: "salesChannel", value: val } });
          }}
          label="Sales Channel"
          required={true}
          xPlacement="bottom"
          onSearchHandler={(e) => console.log("Search input:", e.target.value)}
          dropdownClass={"w-full"}
          dropdownButtonClass={
            "rounded-md !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple !rounded-md border-slate-300"
          }
          labelClasses={"text-lg text-deep-purple"}
        />
      </div> */}
      <div className="relative">
        <Checkbox
          checkboxLabel={t("eTicket")}
          checkboxLableClass={"text-base"}
          checkboxName="eTicket"
          checked={values?.eTicket}
          onChange={handleFormChange}
        />
      </div>
      <div className="relative">
        <Checkbox
          checkboxLabel={t("Pick up at event")}
          checkboxLableClass={"text-base"}
          checkboxName="pickupAtEvent"
          checked={values?.pickupAtEvent}
          onChange={handleFormChange}
        />
      </div>
    </div>
  );
};

export default AdvancedSettingsTicket;
